/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable vars-on-top */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useReducer } from 'react'
import XLSX from "sheetjs-style";
import clsx from 'clsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { createStyles, makeStyles } from "@material-ui/core/styles";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import Stack from '@mui/material/Stack';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Grid} from '@mui/material';
import moment from 'moment';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
// import MenuItem from '@mui/material/MenuItem'
// import Select from '@mui/material/Select';
import { connect, useDispatch,useSelector } from 'react-redux'
import TablePagination from "@mui/material/TablePagination";
import { useHistory } from "react-router-dom";
import Table from '../Table/Table';
// import Button from '@mui/material/Button';
import { Button } from '../../atomicComponents';
// import buttoncss from '../../atomicComponents/Button/Button.module.css';
import styles from "./PendingBAR.module.css"
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
// import TableSimple from '../../atomicComponents/TableSimple/TableSimple';
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { withAllowedOperationsProvider } from '../../hocs'
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from '../../utils/utils';


const useStyles = makeStyles(theme =>
    createStyles({
      smallRadioButton: {
        "& svg": {
          width: "0.7em",
          height: "0.7em"
        }
      }
    })
    );

    

function UnBookedHrsForm() {
  const dispatch= useDispatch();
    const classes = useStyles();
  
  
  
    const workAreaList= [
      {value: 'all', label: "ALL"},
      {value: 'pvbuEng', label: "PV BU Engineering"},
      {value: 'cvbuEng', label: "CV BU Engineering"},
      {value: 'evbuEng', label: "EV BU Engineering"},
    ];
    const bcNoList= [
      {value: 'all', label: "ALL"},
      {value: '0002100010', label: "0002100010"},
      {value: '0002200020', label: "0002200020"},
      {value: '0002200010', label: "0002200010"},
    ];
    const [asnCount, setAsnCount] = useState(0);
    const [tableData, setTableData] = useState([]);
    const handleOpen = () => setIsPopupOpen(true);
    const handleClose = () => setIsPopupOpen(false);
    const [toDate, setToDate] = useState();
    const [fromDate, setFromDate] = useState();
    const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
    const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
    const [viewDisplay, setViewDisplay] = useState(false);
    const [tableArray, setTableArray] = useState([]);
    const [allTableData,setAllTableData]=useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const auth = useSelector((state) => state.auth); // useSelector
    const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
    const { showPopup } = usePopupManager();
    const history = useHistory();
    const [myState, setState] = React.useState(
      {
        poNo: "",
        stmNo: "",
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
        checkFlag: false,
        checkType4:null
  
      });

      const  userLists=['SA','DS']
      const filterData=auth?.userRole?.filter((data)=> userLists?.includes(data))
      const[filterList,setFilterList]=useState(filterData) 

      const HEIGHT = '300px';
      const FILENAME = 'Un-Reviewed_Hrs_Report';

      const setCount = count => {
        setAsnCount(count);
      };
      let {
        userName,
        personNumber,
        companyCode,
        userRole,
        } = auth;
        let UserRoles = userRole;
        let SAFlag = UserRoles.includes("SA");
        let DSFlag = UserRoles.includes("DS");
        let requiredUsers= ["DS","SA"];
        const userList = userRole.filter(role => requiredUsers.includes(role));
    

        // console.log(UserRoles,"UserRoles", SAFlag,"MangerFlag", DSFlag ,"DSFlag")

      const ROW_HEIGHT = 38;
      const baseDefaultColumns = [
        {
          width: 100,
          title: 'Manager BC Number',
          field: 'manager_bc',
          enableSearch: true,
          enableFilter: true,

        },
        {
          width: 250,
          title: 'Manager BC Description',
          field: 'manager_bc_desc',
          enableSearch: true,
          enableFilter: true,

        },
        {
          width: 80,
          title: 'Manager Id',
          field: 'manager_id',
          enableSearch: true,
          enableFilter: true,
        },
        {
          width: 220,
          title: 'Manager Name',
          field: 'manager_name',
          enableSearch: true,
          enableFilter: true,
        },
       
        {
          width: 80,
          title: 'Manager Grade',
          field: 'manager_grade',
          enableSearch: true,
          enableFilter: true,
        }, 
        {
          width: 100,
          title: 'Employee BC Number',
          field: 'emp_bc',
          enableSearch: true,
          enableFilter: true,
        },
        {
          width: 250,
          title: 'Employee BC Description',
          field: 'emp_bc_desc',
          enableSearch: true,
          enableFilter: true,

        },
        { 
          width: 80,
          title: 'Employee ID',
          field: 'pers_no',
          enableSearch: true,
          enableFilter: true,
        },
    
        { 
          width: 180,
          title: 'Employee Name',
          field: 'employee_name',
          enableSearch: true,
          enableFilter: true,
        },

        { 
          width: 80,
          title: 'Employee Grade',
          field: 'emp_grade',
          enableSearch: true,
          enableFilter: true,
        },
    
        { 
          width: 150,
          title: 'Company',
          field: 'company',
          enableSearch: true,
          enableFilter: true,
        },
       
        { 
          width: 100,
          title: 'Booking Date',
          field: 'booking_date',
          enableSearch: true,
          enableFilter: true,
        },
       { 
          width: 100,
          title: 'Hrs Available For Booking',
          field: 'hrs_available_for_booking',
          enableSearch: true,
          enableFilter: true,
        }, 
        { 
          width: 100,
          title: 'Applied Date',
          field: 'applied_date',
          enableSearch: true,
          enableFilter: true,
        },

        { 
          width: 80,
          title: 'Hours',
          field: 'hours',
          enableSearch: true,
          enableFilter: true,
        },
     
        { 
          width: 120,
          title: 'Project / In-Direct Project Number',
          field: 'project_code',
          enableSearch: true,
          enableFilter: true,
        },
        { 
          width: 220,
          title: 'Project / In-Direct Project Description',
          field: 'project_description',
          enableSearch: true,
          enableFilter: true,
        },
        { 
          width: 80,
          title: 'Barrel Code',
          field: 'barrel_code',
          enableSearch: true,
          enableFilter: true,
        },
        { 
          width: 250,
          title: 'Gate (EVM Activity)',
          field: 'gate_desc',
          enableSearch: true,
          enableFilter: true,
        },
        { 
          width: 100,
          title: 'Module (MFL)',
          field: 'mfl_id',
          enableSearch: true,
          enableFilter: true,
        },
        // { 
        //   width: 250,
        //   title: 'Indirect Project / In-Direct Project Number / Description',
        //   field: 'project_code',
        //   enableSearch: true,
        //   enableFilter: true,
        // },

        
        

      ];

      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
      }; 

      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };

    

      const handleUserRoleDetails= (e) => {
        let userData = e;
         // console.log(e,'e');
       
         setState((prevState) => ({ ...prevState, UserRole:e}));
         setViewDisplay(true);
         setRowsPerPage(10)
         setPage(0)
         setLoading(true);
        //  let headerss = new Headers();
        //  const token = `${auth.sessionId}`; 
        //  headerss.append("authorization", token);
        //  headerss.append("Content-Type", "application/json");
     
         if (userData === "DS"){
           const apiFormatedData = {
          "pers_no":sanitizeNumeric(personNumber),
          "user_role":userData,
          "co_code":sanitizeCoCodeNumeric(companyCode),
          "dtfrom":null,
          "dtto":null       
         };
        let apiFormatedDataJson = JSON.stringify(apiFormatedData);
        const headerss = new Headers();
        headerss.append("Content-Type", "application/json");
        fetch(`${baseUrl}reports/UnReviewedHrsReport`, {
          method: "POST",
          headers: headerss,
          credentials:'include',
          body: apiFormatedDataJson,
        })
          .then((response) => {
          
            dispatch(setLogin({...auth, recentStatus: response.status}))
            let responsecode=response.status
            if(responsecode===403){
             setLoading(false);
            }
            return response.json();
            })
          .then((responseJson) => {
            if (responseJson.msg=="Success" && responseJson.data.length !== 0) {
              setLoading(false);
              setState((prevState) => ({ ...prevState, tableFlag: true }));
              const finalList = [];
              responseJson.data.map((row, index) => {
                finalList.push({
                  id: index,
                  ...row,
                });
              });
              setAllTableData(finalList)
            setTableArray(finalList)
           
             
            }
            else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
              setLoading(false);
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "No Records Found",
            })
            setAllTableData([])
            setTableArray([])
            } 
            else if(responseJson && responseJson.msg=="Fail")  {
              setLoading(false);
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: responseJson.data,
            })
            setAllTableData([])
            setTableArray([])
            } 
          
            
          })
          .catch((error) => {
            setLoading(false);
            setAllTableData([])
            if (error.response) {
              showPopup({
                      type: MESSAGE_TYPE.FAILURE,
                      contextText: MESSAGE_TYPE.FAILURE,
                      info: "Oops! Something went wrong. Please try again later. Please try again later",
                  })
            }
            else {
              showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: "There might be Network issue, please try after some time",
                })
            }
          });
     
         }
         
         if (userData === "SA"){
          const apiFormatedData = {
         "pers_no":sanitizeNumeric(personNumber),
         "user_role":userData,
         "co_code":sanitizeCoCodeNumeric(companyCode),
         "dtfrom":null,
         "dtto":null       
        };
       let apiFormatedDataJson = JSON.stringify(apiFormatedData);
       const headerss = new Headers();
       headerss.append("Content-Type", "application/json");
       fetch(`${baseUrl}reports/UnReviewedHrsReport`, {
         method: "POST",
         headers: headerss,
         credentials:'include',
         body: apiFormatedDataJson,
       })
         .then((response) => {
         
          dispatch(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoading(false);
          }
          return response.json();
          })
         .then((responseJson) => {
           if (responseJson.msg=="Success"  && responseJson.data.length !== 0) {
            setLoading(false);
             setState((prevState) => ({ ...prevState, tableFlag: true }));
             const finalList = [];
             responseJson.data.map((row, index) => {
               finalList.push({
                 id: index,
                 ...row,
               });
             });
             setAllTableData(finalList)
             setTableArray(finalList)
           
           
           }
           else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "No Records Found",
          })
          setAllTableData([])
          setTableArray([])
          }
          else if(responseJson && responseJson.msg=="Fail")  {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data,
          })
          setAllTableData([])
          setTableArray([])
          }
         
         })
         .catch((error) => {
          setAllTableData([])
          setLoading(false);
          if (error instanceof TypeError) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "There might be Network issue, please try after some time",
          })
          } else {
            // Handle HTTP errors
            console.error('HTTP Error:', error);
            if (error.response) {
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Oops! Something went wrong. Please try again later",
            })
            }
          }
         });
    
        }
        };

        useEffect(()=>{
          if(myState.checkType4 !==null){
            handleUserRoleDetails(myState.checkType4)
          }
         
        },[myState.checkType4])

        useEffect((page,rowsPerPage) => {
          if(filterList?.length==1){
            setViewDisplay(true);
            setRowsPerPage(10)
            setLoading(true);
            if (userRole.includes("SA")) {
              userRole = "SA";
            } 
            else if (userRole.includes("DS")){
              userRole = "DS";
            }
            // if (userData =="SA") {
            const apiFormatedData = {
              "pers_no":sanitizeNumeric(personNumber),
              "user_role":userRole,
              "co_code":sanitizeCoCodeNumeric(companyCode),
              "dtfrom":null,
              "dtto":null       
             };
            let apiFormatedDataJson = JSON.stringify(apiFormatedData);
            const headerss = new Headers();
            headerss.append("Content-Type", "application/json");
            fetch(`${baseUrl}reports/UnReviewedHrsReport`, {
              method: "POST",
              headers: headerss,
              credentials:'include',
              body: apiFormatedDataJson,
            })
              .then((response) => {
                
                dispatch(setLogin({...auth, recentStatus: response.status}))
                let responsecode=response.status
                if(responsecode===403){
                 setLoading(false);
                }
                return response.json();
                })
              .then((responseJson) => {
                if (responseJson.msg=="Success" && responseJson.data.length !== 0) {
                  setLoading(false);
                  setState((prevState) => ({ ...prevState, tableFlag: true }));
                  const finalList = [];
                  responseJson.data.map((row, index) => {
                    finalList.push({
                      id: index,
                      ...row,
                    });
                  });
                  setAllTableData(finalList)
                  setTableArray(finalList)
                  setState((prevState) => ({ ...prevState, tableFlag: true }));
               
                } 
                else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
                  setLoading(false);
                  showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: "No Records Found",
                })
                setAllTableData([])
                setTableArray([])
                }
                else if(responseJson && responseJson.msg=="Fail")  {
                  setLoading(false);
                  setAllTableData([])
                  showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: responseJson.data,
                })
                } 
               
              })
              .catch((error) => {
                setLoading(false);
                setAllTableData([])
                if (error instanceof TypeError) {
                  showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "There might be Network issue, please try after some time",
                })
                } else {
                  // Handle HTTP errors
                  console.error('HTTP Error:', error);
                  if (error.response) {
                    showPopup({
                      type: MESSAGE_TYPE.FAILURE,
                      contextText: MESSAGE_TYPE.FAILURE,
                      info: "Oops! Something went wrong. Please try again later",
                  })
                  }
                }
              });
          } 
          
        }, [filterList]);

      // useEffect(() => {
      //   setViewDisplay(true);
      //   setTableArray(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))

      // }, [rowsPerPage,page]);

      const newKeySequence = [
            'id',
            'manager_bc',
            'manager_bc_desc',
            'manager_id',
            'manager_name',
            'manager_grade',
           'emp_bc',
            'emp_bc_desc',
            'pers_no',
            'employee_name',
            'emp_grade',
            'company',
            'booking_date',
            'hrs_available_for_booking',
            'applied_date',
            'hours',
            'project_code',
            'project_description',
            'barrel_code',
            'gate_desc',
            'mfl_id',
    ];
    
      function changeKeySequence(data, keySequence) {
        console.log(data);
        return data.map((dict) => {
          const newDict = {};
          keySequence.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(dict, key)) {
              newDict[key] = dict[key];
            }
          });
          return newDict;
        });
      }

      function downloadExcel(data) {
      const modifiedList = changeKeySequence(data, newKeySequence);
      console.log(modifiedList);
        const columnsKeys = {
          'id':'Id',
          'manager_bc':'Manager BC Number',
          'manager_bc_desc':'Manager BC Description',
          'manager_id':'Manager Id',
          'manager_name':'Manager Name',
          'manager_grade':'Manager Grade',
          'emp_bc': 'Employee BC Number',
          'emp_bc_desc':'Employee BC Description',
          'pers_no':'Employee ID',
          'employee_name':'Employee Name',
          'emp_grade':'Employee Grade',
          'company':'Company',
          'booking_date':'Booking Date',
          'hrs_available_for_booking':'Hrs Available For Booking',
          'applied_date': 'Applied Date',
          'hours':'Hours',
          'project_code':'Project / In-Direct Project Number',
          'project_description':'Project / In-Direct Project Description',
          'barrel_code':'Barrel Code',
          'gate_desc':'Gate (EVM Activity)',
          'mfl_id':'Module (MFL)',
        }
        modifiedList.forEach((item, index) => {item.id = index + 1;});
        const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
          acc[columnsKeys[key] || key] = dict[key];
          return acc;
        }, {}));
        console.log(updateExportData,'updateExportData');
        const sheet = XLSX.utils.json_to_sheet(updateExportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
        XLSX.writeFile(workbook, 'Un-Reviewed Hrs Report.xlsx');
      }
      
    const renderForm = () => (
      <div
        className={styles.formGroup}
        // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
        // onClick={() => changeBackgroundColor('processInfoBg')}
      >
        
        <Grid
          container
          spacing={1}
          style={{ display: 'flex', justifyContent: "center", marginTop: "10px" }}
          columns={12}
        >
     <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                value={fromDate}
                // onChange={(e) => { handleDate(e, 'fromDate') }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="dd/mm/yyyy"
                onChange={(e) => { setFromDate(e)}}
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker
                // isMandatory 
                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                value={toDate}
                // onChange={(e) => { handleDate(e, 'toDate')}}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                onChange={(e) => { setToDate(e)}}
                emptyLabel="dd/mm/yyyy"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }
        </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select Work Area</label>
            </div>
            <div className={styles.formDiv}>

              <CustomSelect
                isDisabled={myState.checkFlag}
                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={workAreaList}
                value={myState.bodyBuilder}
                // onChange={(e) => { handleSelect(e, 'bodyBuilder') }}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.bodyBuilderFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "81px" }} className={styles.error}>Body builder Code is mandatory field</div>

          }
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select BC No.</label>
            </div>
            <div className={styles.formDiv}>

              <CustomSelect

                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={bcNoList}
                value={myState.chassisNo}
                // onChange={(e) => { handleSelect(e, 'chassisNo') }}
                name="rso"
                jointOption={false}
              />
            </div>
          </div>

        </Grid>
        </Grid>
  
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={3}>
            <div className={styles.rowDiv}>
            
              <div className={styles.formDiv}>
                         <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton,
                    )}
                    variant="primary"
                    //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                    // onClick={() => runPreSubmissionChecks() && handleSubmit()}
               //     disabled={(myState.chassisNo == null)}
                    data-testid="confirm-action"
                    style={{marginRight: "5px"}}
                  >
                    View
                  </Button>
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton,
                    )}
                    variant="primary"
               //     disabled={(myState.chassisNo == null)}
                    data-testid="confirm-action"
                    style={{marginRight: "5px", width: 'fit-content'}}
                  >
                    Export To Excel
                  </Button>
                  <Button
            className={clsx(styles.actionButton, styles.resetButton)}
            variant="tertiary"
            onClick={handleOpen}
            style={{marginRight: "5px"}}
            >
            Cancel
          </Button>
              </div>
            </div> 
          </Grid>
        </Grid>
      </div>
    )

    const handleCheck4=(e)=>{
      setState((prev)=>({
        ...prev,
        checkType4:e.target.value
      }))
    }


    const renderTable = () => (
      <div >
        <div style={{display:"flex"}}>
        {DSFlag ? (
       <>
      
         <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4} 
             >
               <FormControlLabel 
                 value="DS"
                 name="status4"
                
                 label="Departmental SPOC"
                control={<Radio size="small" />}  />
             </RadioGroup>
      
       </>
      ):("")}

      {SAFlag ? (
       <>
      
          <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4}              
             >
               <FormControlLabel 
                 value="SA"
                 name="status4"
                
                 label="Super Admin"
                control={<Radio size="small" />}  />
             </RadioGroup>
     
       </>
      ) : ("")}  

        </div>

             
        {myState.UserRole &&   tableArray?.length > 0  && 
       <>
        <ReportTable columns={baseDefaultColumns} data={allTableData} height='280px' fileName={FILENAME} />
{/*       
       <Table
        viewDisplay={viewDisplay}
         columns={baseDefaultColumns}
         defaultColumns={baseDefaultColumns}
         rowHeight={ROW_HEIGHT}
            rows={tableArray}
 //          rows={[
 //           {
 //            manager_name:"Mahesh Ejgar",manager_id:"12374",mgrade:"L5",EMPid:"922792",EmpName:"Rutuja Chavan",
 //            grade:"L2",empcompanyname:"TML",applieddate:"12-02-2023",bookingdate:"16-03-2023",hrsAvailableForBook:"01-04-2023",hours:"8.00",projectCode:"2736dw",projectDescription:"Allocated Operator", barrelCode:"",
 //            indirectProjectCode:"NWK038", indiectDescription:"Booking For TTL",bcno:"000220020",employeeDescription:"Advance Engineering",pendingColumnName:"pendingColumnName"
 //           },
           
 // ]}
 secondaryActions={[
   {
     name: "Export",
     getFilteredData: true,
     authOperation: "create-project",
     shouldEnable: (tableArray) => tableArray,
     actionFn: filteredData => {
       // goTo(selected),
       // handleExport(filteredData);
       // ExportFile(filteredData)
       downloadExcel(filteredData)
     },
   },
 ]}

         setAsnCount={setCount}
         isDataLoading={false}
         actionButtons
       //    onRowSelect={(e) => { console.log('onRowSelect call') }}
       />
       <TablePagination
             rowsPerPageOptions={[10, 25, 100]}
             component="div"
             count={allTableData?.length}
             rowsPerPage={rowsPerPage}
             page={page}
             onPageChange={handleChangePage}
             onRowsPerPageChange={handleChangeRowsPerPage}
             
           /> */}
     </>
      
 
   }

    
     

    </div>
   
      );


    

  
    

      const renderReport1 = () => (
        <div
          className={styles.formGroup}
      
        >
          <div
            //  className={styles.customeTable}
            className={styles.col2} style={{
              width: "100%",
              height: "100%",
              marginTop: "10px"
            }}
          >
             {/* {loading ? (
              <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                   <Truckloading />
                </div>
           
            ) : (
               */}
               
                <>
                <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME} />
            {/* <Table
              viewDisplay={viewDisplay}
              columns={baseDefaultColumns}
              defaultColumns={baseDefaultColumns}
              rowHeight={ROW_HEIGHT}
                rows={tableArray}

              secondaryActions={[
                {
                  name: "Export",
                  getFilteredData: true,
                  authOperation: "create-project",
                  shouldEnable: (tableArray) => tableArray,
                  actionFn: filteredData => {
                    // goTo(selected),
                    // handleExport(filteredData);
                    // ExportFile(filteredData)
                    downloadExcel(filteredData)
                  },
                },
              ]}
              setAsnCount={setCount}
              isDataLoading={false}
              actionButtons
            //    onRowSelect={(e) => { console.log('onRowSelect call') }}
            />
            <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={allTableData?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    
                  /> */}
            </>
              {/* )} */}
          </div>
      
        </div>)

    return (
      <>
        <div className={clsx(styles.scrollContainer, styles.formContainer)}>
          {/* <CustomFormGroup header='Un-Booked Hrs Report' body={renderForm()} /> */}
          {
          tableData.length===0 && userList.length > 1 &&
          <CustomFormGroup header='Un-Reviewed Hrs Report' body={renderTable()} />
          }
         
          
          {
          tableData.length === 0 && userList.length === 1 &&
          <CustomFormGroup header='Un-Reviewed Hrs Report' body={renderReport1()} />

        }
        {loading ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):""}
        </div>
        </>
        )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});

const App = connect(mapStateToProps, mapDispatchToProps)(UnBookedHrsForm);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);